import clsx from 'clsx';
import styles from './Button.module.scss';
import { ButtonVisualProps, ButtonSizeType } from './types';
import { Typographies, Typography } from '@/components/atoms/Typography';

const ButtonTexts: Record<ButtonSizeType, Typographies> = {
  small: Typographies.CAPTION_REGULAR,
  medium: Typographies.LABEL_2_REGULAR,
  big: Typographies.LABEL_2_REGULAR,
};

export const getButtonClasses = ({
  variant,
  size = 'medium',
  isFullWidth,
  isLoading,
  StartIcon,
  EndIcon,
  disabled,
  className,
}: Omit<ButtonVisualProps, 'children'>) => {
  const shouldBeDisabled = disabled || isLoading;

  return clsx(
    styles.button,
    styles[variant],
    styles[size],
    {
      [styles.is_full_width]: isFullWidth,
      [styles.is_loading]: isLoading,
      [styles.is_with_icons]: StartIcon || EndIcon,
      [styles.is_disabled]: shouldBeDisabled,
    },
    className,
  );
};

export const ButtonContent = ({
  isLoading,
  StartIcon,
  EndIcon,
  size = 'medium',
  children,
}: Pick<ButtonVisualProps, 'isLoading' | 'StartIcon' | 'EndIcon' | 'size' | 'children'>) => {
  if (isLoading) {
    return <span className={styles.loader}></span>;
  }
  return (
    <div className={styles.content}>
      {StartIcon && <StartIcon />}
      <Typography variant={ButtonTexts[size]}>{children}</Typography>
      {EndIcon && <EndIcon />}
    </div>
  );
};
